import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';

import { BaseFormInput } from '../base-form-input';

@Component({
    selector: 'nuso-date-picker-input',
    templateUrl: './date-picker-input.component.html',
    styleUrls: ['./date-picker-input.component.css'],
    standalone: false
})
export class DatePickerInputComponent extends BaseFormInput {
}
